/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { UserModel } from '../models/user-model';
import { UserApplicationModel } from '../models/user-application-model';
import { AppItemQueryResponse } from '../models/app-item-query-response';
import { UserApplicationSearchModel } from '../models/user-application-search-model';
import { NdmsJsonWepAuthResponse } from '../models/ndms-json-wep-auth-response';
import { NdmsTokenRequest } from '../models/ndms-token-request';
@Injectable({
  providedIn: 'root',
})
class NdmsUserManagementService extends __BaseService {
  static readonly AddAppPath = '/view/ndms/usermanagement/AddApp';
  static readonly AllAppsPath = '/view/ndms/usermanagement/AllApps';
  static readonly GetCurrentUserPath = '/view/ndms/usermanagement/CurrentUser';
  static readonly PendingUsersByAppNamePath = '/view/ndms/usermanagement/PendingUsersByAppName';
  static readonly RefreshNdmsTokenPath = '/view/ndms/usermanagement/RefreshNdmsToken';
  static readonly RequestNdmsTokenPath = '/view/ndms/usermanagement';
  static readonly UpdateUserAccessPath = '/view/ndms/usermanagement/UpdateUserAccess';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param userApplicationModel undefined
   * @return Success
   */
  AddAppResponse(userApplicationModel?: UserApplicationModel): __Observable<__StrictHttpResponse<UserModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = userApplicationModel;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/ndms/usermanagement/AddApp`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UserModel>;
      })
    );
  }
  /**
   * @param userApplicationModel undefined
   * @return Success
   */
  AddApp(userApplicationModel?: UserApplicationModel): __Observable<UserModel> {
    return this.AddAppResponse(userApplicationModel).pipe(
      __map(_r => _r.body as UserModel)
    );
  }

  /**
   * @return Success
   */
  AllAppsResponse(): __Observable<__StrictHttpResponse<AppItemQueryResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/view/ndms/usermanagement/AllApps`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<AppItemQueryResponse>;
      })
    );
  }
  /**
   * @return Success
   */
  AllApps(): __Observable<AppItemQueryResponse> {
    return this.AllAppsResponse().pipe(
      __map(_r => _r.body as AppItemQueryResponse)
    );
  }

  /**
   * @return Success
   */
  GetCurrentUserResponse(): __Observable<__StrictHttpResponse<UserModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/view/ndms/usermanagement/CurrentUser`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UserModel>;
      })
    );
  }
  /**
   * @return Success
   */
  GetCurrentUser(): __Observable<UserModel> {
    return this.GetCurrentUserResponse().pipe(
      __map(_r => _r.body as UserModel)
    );
  }

  /**
   * @param userApplicationSearchModel undefined
   * @return Success
   */
  PendingUsersByAppNameResponse(userApplicationSearchModel?: UserApplicationSearchModel): __Observable<__StrictHttpResponse<Array<UserModel>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = userApplicationSearchModel;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/ndms/usermanagement/PendingUsersByAppName`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<UserModel>>;
      })
    );
  }
  /**
   * @param userApplicationSearchModel undefined
   * @return Success
   */
  PendingUsersByAppName(userApplicationSearchModel?: UserApplicationSearchModel): __Observable<Array<UserModel>> {
    return this.PendingUsersByAppNameResponse(userApplicationSearchModel).pipe(
      __map(_r => _r.body as Array<UserModel>)
    );
  }

  /**
   * @param request undefined
   * @return Success
   */
  RefreshNdmsTokenResponse(request?: NdmsTokenRequest): __Observable<__StrictHttpResponse<NdmsJsonWepAuthResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/ndms/usermanagement/RefreshNdmsToken`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<NdmsJsonWepAuthResponse>;
      })
    );
  }
  /**
   * @param request undefined
   * @return Success
   */
  RefreshNdmsToken(request?: NdmsTokenRequest): __Observable<NdmsJsonWepAuthResponse> {
    return this.RefreshNdmsTokenResponse(request).pipe(
      __map(_r => _r.body as NdmsJsonWepAuthResponse)
    );
  }

  /**
   * @param request undefined
   * @return Success
   */
  RequestNdmsTokenResponse(request?: NdmsTokenRequest): __Observable<__StrictHttpResponse<NdmsJsonWepAuthResponse>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = request;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/ndms/usermanagement`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<NdmsJsonWepAuthResponse>;
      })
    );
  }
  /**
   * @param request undefined
   * @return Success
   */
  RequestNdmsToken(request?: NdmsTokenRequest): __Observable<NdmsJsonWepAuthResponse> {
    return this.RequestNdmsTokenResponse(request).pipe(
      __map(_r => _r.body as NdmsJsonWepAuthResponse)
    );
  }

  /**
   * @param userApplicationModel undefined
   * @return Success
   */
  UpdateUserAccessResponse(userApplicationModel?: UserApplicationModel): __Observable<__StrictHttpResponse<UserModel>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = userApplicationModel;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/view/ndms/usermanagement/UpdateUserAccess`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<UserModel>;
      })
    );
  }
  /**
   * @param userApplicationModel undefined
   * @return Success
   */
  UpdateUserAccess(userApplicationModel?: UserApplicationModel): __Observable<UserModel> {
    return this.UpdateUserAccessResponse(userApplicationModel).pipe(
      __map(_r => _r.body as UserModel)
    );
  }
}

export { NdmsUserManagementService }
